import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCallOutgoing: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCallOutgoing"><Path d="M3 3V4C3 13.3888 10.6112 21 20 21H21V14.456L15.7152 12.8705L14.1216 14.4642C12.2053 13.3852 10.6148 11.7947 9.5358 9.87842L11.1295 8.28476L9.54403 3H3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M15 3H21V9H19V6.41421L15 10.4142L13.5858 9L17.5858 5H15V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCallOutgoing;
